import { render, staticRenderFns } from "./EmpReport.vue?vue&type=template&id=220df2a8&scoped=true&"
import script from "./EmpReport.vue?vue&type=script&lang=js&"
export * from "./EmpReport.vue?vue&type=script&lang=js&"
import style0 from "./EmpReport.vue?vue&type=style&index=0&id=220df2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220df2a8",
  null
  
)

export default component.exports